export enum VENDOR {
  Google = 1,
  Bing = 2,
  Facebook = 3,
  Mailchimp = 4,
  FacebookLeads = 7,
  GoogleLeads = 8,
  GoogleSpreadSheets = 9,
  Elead = 10,
  TradeDesk = 11,
  DealerVault = 12,
  VinSolutions = 13,
  CDK = 14,
  DemandLocal = 15,
  DealerSocket = 16,
  Tekion = 17,
  DriveCentric = 18,
  Centro = 19,
  GoogleAnalytics = 20,
  AmazonCognition = 22,
  Brevo = 23,
  Marchex = 24,
  Procede = 25,
  LinkOneInternal = 26,
  Promax = 27,
  HubSpot = 28,
  LaunchLabs = 29,
}

// Maps Admin vendor ids to Link vendor ids
// Admin vendor ID : Link vendor ID
export const ADMIN_VENDOR_MAP: Record<number, number> = {
  21: 11,
  9: 3,
  1: 1,
  27: 22,
}
